









































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { IProposalStatus } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'proposalStatus';
const ns = { namespace };

@Component
export default class ProposalStatusDetail extends BaseDetail<IProposalStatus> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IProposalStatus>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
